/**
 * What the security page tells search engines and link previews — ONE copy, read by today's page
 * (src/pages/Security.tsx) and its rebuild in the new design (src/design/pavilion/pages/security/), the way
 * src/config/missionSeo.ts serves both mission pages (PV5d, design record §7b).
 *
 * THE SHAPE IS READ BY THE GUEST CHAT'S KNOWLEDGE SOURCE (scripts/generate-guest-knowledge-source.mjs lists this
 * file for "/security"): its extractor takes a `title:` / `description:` field whose string sits on the same line, so
 * each stays one line.
 */

/** The props both security pages hand to <SeoHead>. The canonical is SeoHead's own clean address for the page. */
export const SECURITY_SEO = {
  title: 'security | prest0',
  tabTitle: 'security',
  description: 'Enterprise compliance for large law firms: SOC 2 and ISO 27001 inherited from Google Cloud, US data residency, a zero-training policy, and legal AI infrastructure encrypted in transit and at rest.',
} as const;
